import { MarketingPageLinksLocalization } from './types';

const marketingPageLinks: MarketingPageLinksLocalization = {
  impressum: {
    DE: '/impressum',
    CH: '/impressum',
  },
  privacy_policy: {
    DE: '/datenschutz',
    CH: '/datenschutz',
  },
};

export default marketingPageLinks;
